export interface FirmSearchResult {
  firmId: number;
  isTitleEscrow: boolean;
  name: string;
  states: string;
  status: string;
}

/**
 * Returns a deterministically sorted comma-separated list of license states.
 * Trims whitespace from each token and removes empty tokens (e.g. from leading/trailing commas).
 *
 * @param states - Comma-separated license states string.
 * @returns Alphabetically sorted license states string, or an empty string when input is null/undefined.
 */
export const sortLicenseStatesString = (states: string | null | undefined): string => {
  if (!states) {
    return states ?? '';
  }
  return states
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean)
    .sort((a, b) => a.localeCompare(b, 'en-US'))
    .join(',');
};
